import React, {Component} from "react";
import { Redirect, Route, useLocation } from "react-router-dom";

import {Loading} from "custom";
import {mandaAlPortale, daSpostare, ruoloDi} from "../passaggioPortale";


/** L'utente salvato da `/auth/permission` (o dal login), o null se non c'e' o non si legge. */
function utenteInSessione() {
    try {
        const grezzo = sessionStorage.getItem("userData");
        return grezzo === null ? null : JSON.parse(grezzo);
    } catch (e) {
        return null;
    }
}

/** Chi non deve stare nel gestionale vede solo l'attesa, mentre parte il passaggio al portale. */
class VersoIlPortale extends Component {
    componentDidMount() {
        mandaAlPortale(this.props.userData);
    }

    render() {
        return <Loading/>;
    }
}

const AuthProtected = (props) => {
  // ⚠️ Non e' solo per `state.from`: senza, questo componente si disegna UNA volta sola quando si
  // entra nell'area riservata, e i controlli qui sotto non ripartono piu' passando da una pagina
  // all'altra. Con `useLocation` si rivalutano a ogni cambio di pagina.
  const location = useLocation();
  let token = localStorage.getItem("hash");

  if (token === null) {
    return (
        <Redirect to={{ pathname: "/login", state: { from: location } }} />
    );
  }

  const userData = utenteInSessione();

  // Senza l'utente non si sa chi c'e'. Prima, in questo caso, qualunque pagina si apriva senza
  // nessun controllo (per esempio arrivando da /redirect, che salta il giro di App.js). Il login
  // rilegge la sessione dal server (/auth/permission) e torna qui con il ruolo vero.
  if (userData === null) {
    return (
        <Redirect to={{ pathname: "/login", state: { from: location } }} />
    );
  }

  // 🔴 IL GESTIONALE E' SOLO PER ADMIN E CONSULENT. Di solito ci pensa App.js all'avvio; questa e'
  // la seconda difesa, per chi arriva a una pagina senza ricaricare. Qui e non nella singola rotta:
  // cosi' a un docente non si disegna nemmeno la cornice, menu compreso.
  if (daSpostare(userData)) {
    return <VersoIlPortale userData={userData}/>;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
    const userData = utenteInSessione();

    // ⚠️ `ruoloDi`, non `.role`: dopo il login normale userData e' la risposta intera e il ruolo
    // sta in `.user.role` (vedi passaggioPortale.js).
    if (userData !== null) {
        if (!rest.auth.includes(ruoloDi(userData)))
            return (
                <Redirect to={{ pathname: "/unauthorized" }} />
            );
    }

  return (
      <Route
          {...rest}
          render={props => {
            return (<> <Component {...props} /> </>);
          }}
      />
  );
};

export { AuthProtected, AccessRoute };
